import { createAction, props } from '@ngrx/store';
import { SettingEntityAttributes, UserEntity } from '../../entities/user.entity';
import { DaveMutationCreateUserArgs, DaveMutationResetUserTwoFactorArgs, QueryUserArgs } from '../../graphql-types';

export const UsersActionTypes = {
    UpdateUser: createAction('data/user/update', props<{ Payload: UserEntity }>()),
    UpdateUserSettings: createAction('data/user/update/settings', props<{ Payload: SettingEntityAttributes }>()),
    Load: createAction('data/user/load', props<{ Payload?: QueryUserArgs }>()),
    UpdateMany: createAction('data/users/updateMany', props<{ Payload: Array<UserEntity>, updateLatestUpdatedAt?: boolean }>()),
    UpdateAll: createAction('data/users/updateAll', props<{ Payload: Array<UserEntity>, updateLatestUpdatedAt?: boolean }>()),
    UpdateManageUserList: createAction('data/manageUserList/update', props<{ Payload: Array<UserEntity> }>()),
    AddManageUser: createAction(
        'data/manageUserList/add',
        props<{ Payload: DaveMutationCreateUserArgs }>(),
    ),
    ModifyManageUser: createAction('data/manageUser/modify', props<{ Payload: UserEntity }>()),
    DeleteManageUser: createAction('data/manageUser/delete', props<{ Payload: number }>()),


    RemoveOTPRequest: createAction(
        'data/manageUser/otp/remove/request',
        props<{ Payload: DaveMutationResetUserTwoFactorArgs }>()
    ),
    RemoveOTPSuccess: createAction(
        'data/manageUser/otp/remove/success',
        props<{ Payload: UserEntity }>()
    ),
    RemoveOTPFailure: createAction(
        'data/manageUser/otp/remove/failure',
        props<{ Payload: { Errors: any; ToasterMessage?: string } }>(),
    ),
};
